<template>
  <div class="container">
    Nincs jogosultsága a projekt adminisztrációjához!
  </div>
</template>

<script>
export default {
  name: 'no-permission-page',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {},
  watch: {},
};
</script>
ű
